import { gql } from '@apollo/client';

const ENDPOINT = {
    UPDATE_NDDPREFERENCE: gql`
        mutation nddPreference($serviceId: Int!, $nddPreference: String!) {
            updateMyNDD(serviceId: $serviceId, nddPreference: $nddPreference)
        }
    `,
    GET_NDDPREFERENCE: gql`
        query getNDDPreference($serviceId: Int!) {
            getMyNDDPreference(serviceId: $serviceId) {
                nddPreference
            }
        }
    `,
    UPDATE_CONTACT_PERMISSION_GROUP: gql`
        mutation updateMyContactPermission($permissionGroups: [PermissionGroupsResponseInput!]) {
            updateMyContactPermission(permissionGroups: $permissionGroups)
        }
    `,
    GET_PERMISSION: gql`
        query permission {
            getMyPermissionDetails {
                permissionGroupResponse {
                    name
                    permissions {
                        name
                        enabled
                        permission
                    }
                }
                allowThirdParty
            }
        }
    `,
    UPDATE_BILLDELIVERYTYPE: gql`
        mutation updateBillDeliveryType($accountId: String!, $invoiceDeliveryMethod: String!) {
            updateBillDeliveryType(
                accountId: $accountId
                invoiceDeliveryMethod: $invoiceDeliveryMethod
            )
        }
    `,
    GET_PROFILE_DETAILS: gql`
        query getProfileDetails($serviceId: Int!) {
            getMyContactDetails {
                uuid
                phoneNumbers {
                    phoneNumber
                }
                emails {
                    email
                    type
                    validated
                }
                addresses {
                    addressLine1
                    addressLine2
                    addressLine3
                    town
                    county
                    eircode
                    code
                }
                birthDate
                firstName
                lastName
            }
            getMyNDDPreference(serviceId: $serviceId) {
                nddPreference
            }
            getMyPermissionDetails {
                permissionGroupResponse {
                    name
                    permissions {
                        name
                        enabled
                        permission
                    }
                }
                allowThirdParty
            }
        }
    `,
    GET_ACCOUNT_NUMBER: gql`
        query getMyAccountID($accountId: String!) {
            getMyAccountID(accountId: $accountId) {
                billingAccountId
                invoiceDeliveryMethod
            }
        }
    `,
};
/**
 * @name updateNDDPREFERENCEApi - update NDD Preference
 * @param {graphql} Obj.graphql - appoloclient graphql constant
 * @param {String} Obj.token - user access token
 * @param {String} Obj.serviceId - service id for which NDDServiceId is being requested
 * @param {String} Obj.nddPreference - nddPreference for which value is being requested
 * @returns
 */
export const updateNDDPREFERENCEApi = async ({ graphql, serviceId, nddPreference }) => {
    try {
        const res = await graphql.mutate({
            mutation: ENDPOINT.UPDATE_NDDPREFERENCE,
            variables: {
                serviceId,
                nddPreference,
            },
        });
        return res;
    } catch (error) {
        throw new Error(error);
    }
};
/**
 * @name getNDDPREFERENCEApi - calls getNDDPREFERENCE api and returns response
 * @param {GraphQL} Obj.graphql - appoloclient graphql constant
 * @param {String} Obj.token - user access token
 * @param {String} Obj.serviceId - service id for which usage summary is being requested
 * @returns
 */
export const getNDDPREFERENCEApi = async ({ graphql, serviceId }) => {
    try {
        const res = await graphql.mutate({
            mutation: ENDPOINT.GET_NDDPREFERENCE,
            variables: {
                serviceId,
            },
        });
        return res;
    } catch (error) {
        throw new Error(error);
    }
};
/**
 * @name updateMyContactPermissionApi - update contact permission group
 * @param {graphql} Obj.graphql - appoloclient graphql constant
 * @param {String} Obj.token - user access token
 * @param {String} Obj.allowThirdParty - allowThirdParty is being requested
 * @param {String} Obj.permissionGroups - permissionGroups is being requested
 * @returns
 */

export const updateMyContactPermissionApi = async ({
    graphql,
    // allowThirdParty,
    permissionGroups,
}) => {
    try {
        const res = await graphql.mutate({
            mutation: ENDPOINT.UPDATE_CONTACT_PERMISSION_GROUP,
            variables: {
                // allowThirdParty,
                permissionGroups,
            },
        });
        return res;
    } catch (error) {
        throw new Error(error);
    }
};
/**
 * @name permissionApi - calls getpermission api and returns response
 * @param {GraphQL} Obj.graphql - appoloclient graphql constant
 * @param {String} Obj.token - user access token
 * @param {String} Obj.serviceId - service id for which permissionApi is being requested
 * @returns
 */
export const permissionApi = async ({ graphql, token, serviceId }) => {
    try {
        const res = await graphql.query({
            query: ENDPOINT.GET_PERMISSION,
            variables: {
                token: token,
                serviceId: serviceId,
            },
        });

        return res;
    } catch (error) {
        throw new Error(error);
    }
};
/**
 * @name updateBillDeliveryTypeApi - updating Bill Delivery Type
 * @param {graphql} Obj.graphql - appoloclient graphql constant
 * @param {String} Obj.token - user access token
 * @param {String} Obj.accountId - accountId is being requested
 * @param {String} Obj.invoiceDeliveryMethod - invoice method is being requested
 * @returns
 */
export const updateBillDeliveryTypeApi = async ({
    graphql,
    token,
    accountId,
    invoiceDeliveryMethod,
}) => {
    try {
        const resp = await graphql.mutate({
            mutation: ENDPOINT.UPDATE_BILLDELIVERYTYPE,
            variables: {
                accountId,
                invoiceDeliveryMethod,
            },
        });
        return resp;
    } catch (error) {
        console.log('error123', error);
        throw new Error(error);
    }
};
/**
 * @name getProfileDetailsApi - calls getprofiledetails api and returns response
 * @param {GraphQL} Obj.graphql - appoloclient graphql constant
 * @param {String} Obj.token - user access token
 * @param {String} Obj.serviceId - service id for which getprofiledetails is being requested
 * @returns
 */
export const getProfileDetailsApi = async ({ graphql, serviceId }) => {
    try {
        const data = await graphql.query({
            query: ENDPOINT.GET_PROFILE_DETAILS,
            variables: {
                serviceId,
            },
            errorPolicy: 'all',
        });
        return data;
    } catch (error) {
        throw new Error(error);
    }
};
/**
 * @name getMyAccountIDApi - calls getaccountnumber api and returns response
 * @param {String} Obj.token - user access token
 * @param {String} Obj.serviceId - service id for which get account number is being requested
 * @returns
 */
export const getMyAccountIDApi = async ({ graphql, token, accountId }) => {
    try {
        const response = await graphql.query({
            query: ENDPOINT.GET_ACCOUNT_NUMBER,
            variables: {
                accountId,
            },
        });
        return response;
    } catch (error) {
        throw new Error(error);
    }
};
